import { useQuery } from '@tanstack/react-query';
import { fetchExamSubjectCategories } from '../services/examCategoryService';

export function useExamSubjectCategories(examCourseId, categoryId, freePaid = '', enabled = false) {
  return useQuery({
    queryKey: ['examSubjectCategories', Number(examCourseId), Number(categoryId), String(freePaid || '').toUpperCase()],
    queryFn: async () => {
      const payload = await fetchExamSubjectCategories({
        exam_course_id: Number(examCourseId),
        category_id: Number(categoryId),
        free_paid: freePaid || undefined,
      });
      return {
        allSubjectCount: Number(payload?.all_subject_count || 0),
        subjectCategoryList: Array.isArray(payload?.subject_category_list) ? payload.subject_category_list : [],
      };
    },
    enabled: enabled && Number(examCourseId) > 0 && Number(categoryId) > 0,
    staleTime: 5 * 60 * 1000,
  });
}
